module.exports = [{
      plugin: require('E:/Documents/Websites/ronda-lunn/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('E:/Documents/Websites/ronda-lunn/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
